// extracted by mini-css-extract-plugin
var _1 = "DocFlowEpostValidationPreviewButton-moduleDocFlowEpostValidationPreviewButton__Psjor ButtonIcon-moduleicon__Hawdx IconNG-moduleiconContainer__SxWZ0";
export { _1 as "DocFlowEpostValidationPreviewButton" }
